import React, { useEffect, useState } from "react";
import styles from "./index.module.scss";
import ImageSubText from "../../common/components/ImageSubText";
import infinipathIcon from "../../assets/images/infinipath-logo.webp";
import programsIcon from "../../assets/images/Programicons.svg";
import HDB_ICON from "../../assets/images/hdb-icon.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setSideNavId } from "../../reducers/SeekerReducer";
import { getItemInLocalStorage } from "../../services/localStorage";
import { getCall } from "../../services/apiService";
import { endPoints, PORTAL } from "../../constants/urlConstants";
import { USER_ROLE_MAHATRIA, MENU_ID_HDB,API_LIMIT_100 } from "../../constants/textConstants";
import { filterProgramsByTypeStatus } from "../../utils/commonFunctions";
// Menu items data with absolute URLs
const menuItems = [
  {
    id: "hdb",
    text: "HDB",
    selectedImageSrc: HDB_ICON,
    url: "/admin/action-cards",
  },
];

const menuItemsMahatria = [
  // {
  //   id: "infinipath",
  //   text: "infinipath",
  //   selectedImageSrc: infinipathIcon,
  //   url: "sessions",
  // },
  {
    id: "hdb",
    text: "HDB",
    selectedImageSrc: HDB_ICON,
    //Should be mofified later currently keeping it static for demo
    url: "/admin/action-cards",
  },
];

const menuItemsAdmin = [
  {
    id: "infinipath",
    text: "infinipath",
    selectedImageSrc: infinipathIcon,
    url: "sessions",
  },
  {
    id: "hdb",
    text: "HDB",
    selectedImageSrc: HDB_ICON,
    url: "/admin/action-cards",
  },
];

const PortalNavigation: React.FC = () => {
  const userRole = getItemInLocalStorage("seekerDetails")?.role || "";
  const [selectedItem, setSelectedItem] = useState<string>("infiniprayer");
  const [programsList, setProgramsList] = useState<any[]>([]);
  const [filteredPrograms, setFilteredPrograms] = useState<any[]>([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const extractProgramsFromResponse = (data: any) => {
    return Array.isArray(data) ? data : [];
  };
  useEffect(() => {
    // Call the API to fetch programs
    getCall(`${endPoints.program}?limit=${API_LIMIT_100}`, undefined, PORTAL)
      .then((response) => {
        if (response?.data?.data?.data) {
          const extractedPrograms = extractProgramsFromResponse(
            response.data.data.data,
          );
          setProgramsList(extractedPrograms);
          const filteredPrograms = filterProgramsByTypeStatus(extractedPrograms, {
            type: "PT_HDBMSD",
            status: "published",
          },
          false,
        );
          setFilteredPrograms(filteredPrograms);
        } else {
          console.error("No data found in response");
        }
      })
      .catch((error) => {
        console.error("There is an Error fetching programs:", error);
      });
  }, [navigate]);

  const handleNavigation = (id: string, url: string) => {
    setSelectedItem(id);
    dispatch(setSideNavId(id)); // Update the sideNavId in the state

    if (id === MENU_ID_HDB && filteredPrograms.length === 1) {
      navigate(`/admin/hdb-dashboard/${filteredPrograms[0].id}`);
    } else {
      navigate(url);
    }
  };
  const reqMenuItems =
    userRole === "mahatria"
      ? menuItemsMahatria
      : userRole === "admin"
        ? menuItemsAdmin
        : menuItems;

  //To set the initial selected item based on user role
  useEffect(() => {
    if (userRole === "mahatria") {
      setSelectedItem("hdb");
    } else {
      setSelectedItem("hdb");
    }
  }, []);

  return (
    <div
      className={
        selectedItem === "infinipath" ? styles.sideBarTop : styles.sidebar
      }
    >
      <div className={styles.sidebarMenu}>
        {reqMenuItems?.map((item) => (
          <div
            key={item.id}
            className={`${styles.menuItem} ${selectedItem === item.id ? styles.selected : ""}`}
            onClick={() => handleNavigation(item.id, item.url)}
          >
            <ImageSubText
              selectedImageSrc={item.selectedImageSrc}
              text={item.text}
              isSelected={selectedItem === item.id}
              containerClass={styles.imageSubTextContainer}
              imageContainerClass={styles.imageContainer}
              imageClass={styles.image}
              textClass={styles.text}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PortalNavigation;
